/*
 * Price-gate dialog controller.
 *
 * Intercepts a plain left-click on any "Ver o preço" CTA (.price__cta-login)
 * and opens the shared #PriceGateModal, explaining the wholesale price gate
 * before sending the visitor to login / register.
 *
 * The CTA stays a real <a href="/pages/cadastro">, so no-JS / approved
 * customers and Cmd/Ctrl/Shift/middle-click navigate normally.
 *
 * The dialog itself is <modal-dialog> (assets/global.js): it handles
 * focus-trap, ESC / backdrop / close-button, and body scroll lock. The
 * login / register buttons are anchors and navigate on their own.
 */
(function () {
  function track(event, props) {
    if (typeof window.arvenneTrack === 'function') window.arvenneTrack(event, props)
  }

  function ctaLocation(el) {
    if (el.closest('.card--product, .card-wrapper')) return 'product_card'
    const pageType = (window.__arvenneAnalyticsConfig || {}).pageType
    if (pageType === 'product') return 'product_page'
    return pageType || ''
  }

  document.addEventListener('click', function (event) {
    const cta = event.target.closest('.price__cta-login')
    if (cta) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return

      const modal = document.querySelector('#PriceGateModal')

      // gate_state (guest|pending|incomplete|rejected) segments the funnel —
      // notably the logged-in "incomplete" customer prompted to finish signup.
      track('view_price_clicked', {
        location: ctaLocation(cta),
        product_id: cta.getAttribute('data-product-id') || '',
        product_title: cta.getAttribute('data-product-title') || '',
        gate_state: (modal && modal.dataset.gateState) || '',
      })

      if (!modal) return

      event.preventDefault()
      modal.show(cta)
      return
    }

    // Header account button (logged-out): open the same price-gate dialog
    // instead of going straight to login. Stays a real <a href="…/login">,
    // so no-JS / gate-disabled / modifier-clicks navigate normally.
    const gateOpener = event.target.closest('[data-price-gate-open]')
    if (gateOpener) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return

      const modal = document.querySelector('#PriceGateModal')
      if (!modal) return

      event.preventDefault()
      modal.show(gateOpener)
      return
    }

    const modalBtn = event.target.closest('.price-gate-modal__btn')
    if (modalBtn) {
      const intent = modalBtn.getAttribute('data-intent') || ''
      const modal = modalBtn.closest('modal-dialog')
      track('price_gate_modal_cta_clicked', {
        intent: intent,
        location: 'price_gate_modal',
        gate_state: (modal && modal.dataset.gateState) || '',
      })

      // "Entendi" — não navega, só fecha o dialog (modal-dialog liga o close
      // apenas ao primeiro [id^="ModalClose-"], que é o X).
      if (intent === 'acknowledge' && modal) modal.hide()
    }
  })
})()
